import Enum from "../../enums/Enum";

const EnumExtraDayType = new Enum({
    EXTRA_PAY: {name: "Extra Pay"},
    FLEXIBLE: {name: "Flexible Hours"},
});

export default EnumExtraDayType;
